import { getApiUrl } from "../utils/get-api-url";

interface getSuggestionsProps {
  searchTerm: string;
  userId: string;
  showAll: boolean;
  resultSetType: string;
}

export const getSuggestions = async (payload: getSuggestionsProps) => {
  const params = new URLSearchParams({
    ...payload,
    showAll: payload.showAll.toString()
  }).toString();

  const apiUrl = getApiUrl("quotesapi");
  const fullUrl = `${apiUrl}/quotes/search/suggest${
    params ? `?${params}` : ""
  }`;

  const response = await fetch(fullUrl, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache"
    },
    credentials: "include"
  });

  const { headers: resHeaders, status, ok } = response;
  const contentType = resHeaders.get("content-type");

  if (!contentType || !contentType.includes("application/json")) {
    throw new Error("Network request failed. Status: " + status);
  }
  const result = await response.json();

  if (!ok) throw new Error(result.message || "Quotes API request failed");

  return result;
};
